import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// The container is mounted beside the routes, outside every ErrorBoundary: a
// toast whose content React cannot render (a server error body passed as an
// object) used to unmount the whole app — a white page. This boundary drops the
// broken toasts by remounting the container, and the app stays up.
export class ToastBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false, generation: 0 };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("[Toaster] a toast could not be rendered and was dropped", error);
    this.setState(({ generation }) => ({ failed: false, generation: generation + 1 }));
  }

  render() {
    if (this.state.failed) return null;
    return <React.Fragment key={this.state.generation}>{this.props.children}</React.Fragment>;
  }
}

const Toaster = () => (
  <ToastBoundary>
    <ToastContainer
      position="bottom-left"
      width="auto"
      height="80px"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnVisibilityChange
      draggable={false}
      pauseOnHover={true}
    />
  </ToastBoundary>
);

export default Toaster;
